import { render, staticRenderFns } from "./termsList.vue?vue&type=template&id=065f6400"
import script from "./termsList.vue?vue&type=script&lang=js"
export * from "./termsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports